import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ErrorPage from "./pages/ErrorPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import AppRoutes from "./router/routes";
import { ProtectedRoute, ProtectedAuthRoute } from "./router/Protector";
import { useContext } from "react";
import { AppContext } from "./context/AppContext";
import Errorpage from "./components/custom/Errorpage";

function App() {
  const { tokenError } = useContext(AppContext);

  return (
    <>
      {tokenError == null ? (
        <Router>
          <Routes>
            {AppRoutes.map((route, index) => {
              return !route.isProtected && !route.isProtectedAuth ? (
                <Route
                  key={index}
                  path={route.path}
                  element={route.element}
                  exact="true"
                />
              ) : !route.isProtected && route.isProtectedAuth ? (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <ProtectedAuthRoute>{route.element}</ProtectedAuthRoute>
                  }
                  exact="true"
                />
              ) : (
                <Route
                  key={index}
                  path={route.path}
                  element={<ProtectedRoute>{route.element}</ProtectedRoute>}
                  exact="true"
                />
              );
            })}
          </Routes>
        </Router>
      ) : (
        <Errorpage
          errorTitle={"Unexpected Error"}
          errorMsg={tokenError?.message ?? "Token expired"}
        />
      )}
    </>
  );
}

export default App;
